<template>
  <div>
    <ContentBox title="基础信息" class="content-box">
      <el-form ref="form" :model="model" :rules="rules" label-width="130px" label-position="left" hide-required-asterisk>
        <el-row>
          <el-col :span="20">
            <el-form-item label="订单名称" prop="orderId">
              <CommonLazySelect
                v-model="orderForm.orderId"
                :filter="orderFilter"
                :primaryKey="primaryKey"
                :optionsMap="orderOptionsMap"
                :extendField="true"
                serviceName="getOrderList"
                class="demo-ruleForm-select"
                @selected="handleOrderSelected"
              ></CommonLazySelect>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="计划类型" prop="planType">
              <el-radio-group v-model="model.planType" @change="handleChangePlanType">
                <el-radio-button v-for="(item, index) in planTypeList" :key="index" :label="item.value">{{ item.label }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="model.planType === 1">
          <el-col :span="20">
            <el-form-item label="程序化来源" prop="scheduleSource">
              <el-select
                class="demo-ruleForm-select"
                v-model="model.scheduleSource"
                @input="handleChangeScheduleSource"
                filterable
                placeholder="请选择"
              >
                <el-option v-for="item in scheduleSourceList" :key="'scheduleSource'+item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="showSupportMode.pdb || showSupportMode.pd || showSupportMode.cpdb">
          <el-col :span="20">
            <el-form-item label="程序化类型" prop="supportMode">
              <el-radio-group v-model="model.supportMode">
                <el-radio-button :label="0" v-if="showSupportMode.pdb">保价保量(PDB)</el-radio-button>
                <el-radio-button :label="1" v-if="showSupportMode.pd">保价不保量(PD)</el-radio-button>
                <el-radio-button :label="2" v-if="showSupportMode.cpdb">保价全量(CPDB)</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="结算方式" prop="payment">
              <el-select class="demo-ruleForm-select" v-model="model.payment" filterable placeholder="请选择">
                <el-option v-for="item in paymentList" :key="'payment'+item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="广告位" prop="spaceId">
              <el-select v-model="model.spaceId" filterable class="demo-ruleForm-select" @change="handleSpaceChange">
                <el-option v-for="item in spaceOptions" :key="'space'+item.spaceId" :label="item.spaceName" :value="item.spaceId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="speed" :span="20">
            <el-form-item label="投放速度" prop="trafficSpeed">
              <el-radio-group v-model="model.trafficSpeed" @change="handleSpeedChange">
                <el-radio-button :label="2">匀速</el-radio-button>
                <el-radio-button :label="1">快速</el-radio-button>
                <el-radio-button :label="3">智能</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="model.trafficSpeed === 2 || model.trafficSpeed === 3">
          <el-col>
            <el-form-item label="TA浓度">
              <div class="flex-form-panel">
                <el-radio-group v-model="pvRateType" @change="model.pvRate = ''">
                  <el-radio-button :label="0">无</el-radio-button>
                  <el-radio-button :label="1">按TA</el-radio-button>
                </el-radio-group>
                <template v-if="pvRateType === 1">
                  <el-select class="flex-form-content" v-model="model.pvRate" filterable placeholder="请选择">
                    <el-option v-for="item in pvRateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </template>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="媒体方" prop="cableChannelList">
              <CheckBoxGroup v-model="model.cableChannelList" :options="cableChannelOptions"></CheckBoxGroup>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="model.planType === 1">
          <el-col>
            <div class="flex-form-panel">
              <el-form-item label="放量溢出比">
                <el-radio-group v-model="receivePctType" @change="handleChangePctType">
                  <el-radio-button :label="0">默认</el-radio-button>
                  <el-radio-button :label="1">自定义</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <template v-if="receivePctType === 1">
                <el-form-item label-width="0" prop="receivePct">
                  <el-input class="flex-form-content" v-model="model.receivePct"></el-input>&nbsp;%
                </el-form-item>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="flex-form-panel">
              <el-form-item label="曝光溢出比">
                <el-radio-group v-model="exposurePctType" @change="resetExposurePct">
                  <el-radio-button :label="0">默认</el-radio-button>
                  <el-radio-button :label="1">自定义</el-radio-button>
                  <el-radio-button :label="2">溢出比考核</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col v-if="exposurePctType !== 0" class="flex-form-items">
            <el-form-item :label="exposurePctType === 2 ? '考核值' : '溢出比'" label-width="60px" prop="checkExposurePct">
              <el-input class="flex-form-content" v-model.number="model.checkExposurePct" @change="calcExposurePct"></el-input>&nbsp;%
            </el-form-item>
            <template v-if="exposurePctType === 2">
              <el-form-item label="额外溢出" label-width="80px" prop="addExposurePct">
                <el-input class="flex-form-content" v-model.number="model.addExposurePct" placeholder="可填0" @change="calcExposurePct"></el-input>&nbsp;%
              </el-form-item>
              <el-form-item label="总计" label-width="50px" prop="exposurePct">
                <div style="width:160px">
                  <span style="width:60px;font-weight:600">{{ model.exposurePct }}</span>&nbsp;%
                </div>
              </el-form-item>
            </template>
          </el-col>
        </el-row>
        <el-row v-if="showExposureDirectly">
          <el-col>
            <el-form-item>
              <label slot="label">
                计划强植入
                <el-tooltip class="item" effect="light" placement="top-start">
                  <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                  <div slot="content">仅适用于开启实时行为兴趣推荐的广告位，启用后，将不再使用标签匹配规则，在发起合适广告请求时直接展示当前广告。</div>
                </el-tooltip>
              </label>
              <el-radio-group v-model="model.exposureDirectly">
                <el-radio-button :label="1">不启用</el-radio-button>
                <el-radio-button :label="0">启用</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="showCtr">
          <el-col>
            <div class="flex-form-panel">
              <el-form-item label="CTR权重">
                <el-radio-group v-model="ctrType" @change="model.ctr = undefined">
                  <el-radio-button :label="0">不加权</el-radio-button>
                  <el-radio-button :label="1">配置</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <template v-if="ctrType === 1">
                <el-form-item label-width="0" prop="ctr">
                  <el-input class="flex-form-content" v-model="model.ctr" placeholder="1~1000的整数"></el-input>&nbsp;‰
                </el-form-item>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item>
              <template #label>
                IES服务
                <el-tooltip class="item" effect="light" placement="top-start">
                  <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                  <div slot="content">IES开启，计划审核完成后会自动替换IES宏参，并自动获取秒针的监测数据与自有监测数据对比、自动发起预警；
                    关闭后则无法获取秒针监测数据、无法发起自动预警；</div>
                </el-tooltip>
              </template>
              <el-switch v-model="model.iesSwitch" :active-value="1" :inactive-value="0" disabled></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </ContentBox>
    <ContentBox class="content-box">
      <el-button @click="handleCancel()">返回</el-button>
      <el-button type="primary" @click="nextStep()">下一步</el-button>
    </ContentBox>
  </div>
</template>
<script>
import CommonLazySelect from '@/components/common/CommonLazySelect'
import CheckBoxGroup from '@/components/CheckBoxGroup'
export default {
  components: {
    CommonLazySelect,
    CheckBoxGroup
  },
  data() {
    var validateReceivePct = (rule, value, callback) => {
      if (this.receivePctType === 0) {
        return callback()
      }
      if (value === '' || value === undefined) {
        return callback(new Error('请输入溢出比'))
      }
      if (!Number.isInteger(value * 1) || value * 1 <= 0) {
        return callback(new Error('请输入正整数'))
      }
      if (value * 1 > 100000) {
        return callback(new Error('溢出比不能超过100000%'))
      }
      callback()
    }
    var validAssessmentPct = (rule, value, callback) => {
      if (this.exposurePctType === 0) {
        return callback()
      }
      if (value === '' || value === undefined) {
        return callback(new Error(`请输入${this.exposurePctType === 2 ? '考核' : ''}溢出比`))
      }
      if (!Number.isInteger(value * 1) || value * 1 <= 0) {
        return callback(new Error('请输入正整数'))
      }
      if (this.exposurePctType === 1 && value * 1 > 100) {
        return callback(new Error('溢出比不能超过100%'))
      }
      callback()
    }
    var validExtraPct = (rule, value, callback) => {
      if (this.exposurePctType !== 2) {
        return callback()
      }
      if (value === '' || value === undefined) {
        return callback(new Error('请输入额外溢出比'))
      }
      if (!Number.isInteger(value * 1) || value * 1 < 0) {
        return callback(new Error('请输入大于等于0的整数'))
      }
      callback()
    }
    var validExposurePct = (rule, value, callback) => {
      if (this.exposurePctType !== 2 || !this.model.checkExposurePct) {
        return callback()
      }
      if (value > 100) {
        return callback(new Error('溢出比总和不能超过100'))
      }
      callback()
    }

    var validateCtr = (rule, value, callback) => {
      if (this.ctrType === 0) {
        return callback()
      }
      if (value === '') {
        return callback(new Error('请输入CTR权重'))
      }
      if (!Number.isInteger(value * 1) || value * 1 <= 0 || value * 1 > 1000) {
        return callback(new Error('请输入1~1000的整数'))
      }
      callback()
    }
    return {
      directional: null,
      scheduleSourceList: [],
      paymentList: [],
      spaceOptions: [],
      pvRateType: 0,
      pvRateOptions: [],
      rules: {
        orderId: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        spaceId: [{ required: true, message: '请选择广告位', trigger: 'blur' }],
        planType: [{ required: true, message: '请选择计划类型', trigger: 'blur' }],
        scheduleSource: [{ required: true, message: '请选择程序化来源', trigger: 'blur' }],
        payment: [{ required: true, message: '请选择结算方式', trigger: 'blur' }],
        trafficSpeed: [{ required: true, message: '请选择投放速度', trigger: 'blur' }],
        receivePct: [{ validator: validateReceivePct, trigger: 'blur' }],
        checkExposurePct: [{ validator: validAssessmentPct, trigger: 'blur' }],
        addExposurePct: [{ validator: validExtraPct, trigger: 'blur' }],
        exposurePct: [{ validator: validExposurePct, trigger: 'blur' }],
        ctr: [{ validator: validateCtr, trigger: 'blur' }],
        cableChannelList: [{ required: true, message: '请至少选择一个媒体方', trigger: 'change' }]
      },
      model: {
        orderId: null, // 订单ID
        planType: 0, // 计划类型
        scheduleSource: null, // 程序化来源（原计划单来源） 0 自有
        supportMode: null, // 支持的程序化类型 0 保价保量 1 保价不保量
        trafficSpeed: undefined, // 投放速度 1 快速投完  2 匀速投放
        payment: null, // 结算方式
        spaceId: null, // 广告位id
        cableChannelList: [],
        receivePct: 0,
        pvRate: '',
        checkExposurePct: undefined,
        addExposurePct: undefined,
        exposurePct: 0,
        exposureDirectly: 1,
        ctr: undefined,
        iesSwitch: 0,
      },
      spacePctRatio: 0,
      receivePctType: 0, // (放量溢出比 0默认 1自定义)
      exposurePctType: 0,
      ctrType: 0,
      orderFilter: {
        orderName: '',
        useOrderFlag: 0
      },
      primaryKey: {
        orderId: ''
      },
      orderOptionsMap: {
        key: 'orderId',
        label: 'orderName'
      },
      orderForm: {
        orderId: null,
        orderName: '',
        partnerId: null,
        dayBudget: undefined,
        buyType: 0,
        contractBeginDate: '',
        contractEndDate: '',
        totalContract: null,
        contractSn: '',
        sellingType: 1,
        adSalesmanIdList: [],
        description: ''
      },
      cableChannelOptions: [],
      planTypeList: [],
      isBaseInfoChange: true,
      isSpaceChange: true
    }
  },
  watch: {
    'orderForm.orderId'(newValue, oldValue) {
      if (newValue) {
        this.getOrderInfo(newValue)
        this.getScheduleDirect(newValue)
        this.getSpaceList()
      } else {
        this.scheduleSourceList = []
        this.paymentList = []
        this.spaceOptions = []
      }
    },
    model: {
      handler(newVal) {
        this.isBaseInfoChange = true
      },
      deep: true
    }
  },
  computed: {
    showSupportMode() {
      let show = {}
      if (this.model.planType === 1) {
        // 计划类型为1 程序化采买
        if (this.model.scheduleSource) {
          let supportModeType = this.directional.scheduleSourceList.filter(item => item.bizValue === this.model.scheduleSource)
          show = {
            pdb: supportModeType[0].supportMode.includes(0),
            pd: supportModeType[0].supportMode.includes(1),
            cpdb: supportModeType[0].supportMode.includes(2)
          }
        }
      }
      return show
    },
    showCtr() {
      if (!this.model.spaceId) return false
      const space = this.spaceOptions.find(option => option.spaceId === this.model.spaceId)
      if (!space) return false
      return space.spaceGuideIconConfig && space.spaceGuideIconConfig.widthLimit > 0
    },
    showExposureDirectly() {
      if (!this.model.spaceId) return false
      const space = this.spaceOptions.find(option => option.spaceId === this.model.spaceId)
      if (!space) return false
      return space.supportInterestTag === 1
    }
  },
  methods: {
    getCableChannel() {
      const space = this.spaceOptions.find(item => item.spaceId === this.model.spaceId)
      // planType 是否支持程序化0， 1
      const params = {
        orderId: this.orderForm.orderId,
        spaceNo: space ? space.spaceNo : undefined,
        planType: this.model.planType
      }
      this.$service.getCableChannel(params).then(data => {
        this.cableChannelOptions = (data || []).map(item => {
          return {
            label: item.cableName,
            value: item.cableNo,
            selectBox: item.selectBox // 1默认勾选
          }
        })
        // 默认勾选媒体方
        this.handleSetCableChannel()
      })
    },
    handleSpaceChange(val) {
      const space = this.spaceOptions.find(item => item.spaceId === val)
      // 选中广告位后，如果是程序化则取广告位的pdb溢出比
      if (this.model.planType === 1 && space) {
        this.spacePctRatio = space.receivePct
        this.model.receivePct = space.receivePct
      }
      // 根据广告位查询对应媒体方
      if (val && space) {
        this.getCableChannel()
        this.model.trafficSpeed = space.defaultTrafficSpeed
      }
      this.model.exposureDirectly = 1
      this.isSpaceChange = true
    },
    handleChangePctType(val) {
      if (this.receivePctType === 0) {
        this.model.receivePct = this.spacePctRatio
      }
    },
    handleSpeedChange(val) {
      if (this.model.trafficSpeed === 1) {
        this.pvRateType = 0
        this.model.pvRate = ''
      }
    },
    resetExposurePct() {
      this.model.checkExposurePct = undefined
      this.model.addExposurePct = undefined
      this.model.exposurePct = 0
      this.$refs.form.clearValidate()
    },
    calcExposurePct() {
      const checkExposurePct = Number.isInteger(this.model.checkExposurePct * 1) ? this.model.checkExposurePct * 1 : 0
      const addExposurePct = Number.isInteger(this.model.addExposurePct * 1) ? this.model.addExposurePct * 1 : 0
      if (this.exposurePctType === 1) {
        this.model.exposurePct = checkExposurePct
      } else if (this.exposurePctType === 2) {
        this.model.exposurePct = checkExposurePct + addExposurePct
        this.$refs.form.validateField('exposurePct')
      }
    },
    // 获取定向条件
    getScheduleDirect(val) {
      this.$service.getScheduleDirect({ orderId: val }).then(data => {
        this.directional = data
        this.scheduleSourceList = JSON.parse(JSON.stringify(data.scheduleSourceList || []))
          .filter(({ bizValue }) => bizValue !== 0)
          .map(item => {
            return {
              label: item.bizLabel,
              value: item.bizValue,
              supportMode: item.supportMode,
              spaceNoStr: item.adSpaces
            }
          })
        // 计划类型
        this.planTypeList = (data.planTypeList || []).map(item => {
          return {
            label: item.planTypeName,
            value: item.planTypeId
          }
        })
        this.paymentList = data.paymentList.map(item => {
          return {
            label: item.dictLabel,
            value: parseInt(item.dictValue)
          }
        })
        // 结算方式赋值
        if (this.paymentList.length > 0) {
          this.handleSetPayment()
        }
      })
    },
    getBaseDict() {
      this.$service.getBaseDict().then(res => {
        this.pvRateOptions = (res.pvRateList || []).map(item => {
          return {
            value: item.dictValue,
            label: item.dictLabel
          }
        })
      })
    },
    // 获取广告位信息
    getSpaceList() {
      return new Promise((resolve, reject) => {
        const params = {
          orderId: this.model.orderId,
          planType: this.model.planType,
          scheduleSource: this.model.planType === 0 ? 0 : this.model.scheduleSource || 0
        }
        this.$service.getScheduleNeedAdSpace(params).then(data => {
          this.spaceOptions = data.filter(
            item => item.batchBuild === 1 // 过滤可以投放的广告位
          )
          resolve(true)
        })
      })
    },
    handleSetPayment() {
      if (this.model.payment === undefined || this.model.payment === '') {
        this.model.payment = this.paymentList[0].value
      }
    },
    handleSetCableChannel() {
      // 默认勾选所有媒体方并隐藏
      this.model.cableChannelList = this.cableChannelOptions.filter(item => item.selectBox === 1)
        .map(item => item.value)
    },
    // 设置订单ID
    getOrderInfo(val) {
      this.model.orderId = val
    },
    handleChangePlanType() {
      this.model.spaceId = undefined
      if (this.model.orderId) {
        this.getSpaceList()
      }
      this.model.scheduleSource = undefined
    },
    handleChangeScheduleSource(val) {
      this.model.scheduleSource = val
      let defaultSupportMode = null
      if (this.model.scheduleSource || this.model.scheduleSource === 0) {
        // 根据选择的程序化类型找到支持的模式
        let supportModeType = this.directional.scheduleSourceList.filter(item => item.bizValue === this.model.scheduleSource)
        defaultSupportMode = supportModeType[0].supportMode
      }
      if (defaultSupportMode.includes(',')) {
        this.model.supportMode = defaultSupportMode.substring(0, 1)
      } else {
        this.model.supportMode = defaultSupportMode
      }
      this.model.spaceId = undefined
      if (this.model.orderId) {
        this.getSpaceList()
      }
    },
    handleCancel() {
      this.$router.push({
        name: 'adServingManage'
      })
    },
    nextStep() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = this.model
          params.planType = parseInt(params.planType)
          if (params.planType === 0) {
            params.planType = 0
            params.supportMode = 0
            params.scheduleSource = 0
          } else {
            params.supportMode = parseInt(params.supportMode)
          }
          const space = this.spaceOptions.find(item => item.spaceId === this.model.spaceId)
          const baseInfo = {
            trackTypeList: JSON.parse(space.trackTypeList || '[]'),
            spaceNo: space.spaceNo,
            isSpaceChange: this.isSpaceChange,
            isBaseInfoChange: this.isBaseInfoChange,
            targetEvent: space ? space.targetEvent : 0,
            partnerId: this.orderForm.partnerId,
            adTip: space ? space.adTip : 1,
            ...this.cloneDeep(params),
            checkExposurePct: this.exposurePctType === 2 ? params.checkExposurePct : 0,
            addExposurePct: this.exposurePctType === 2 ? params.addExposurePct : 0
          }
          this.$emit('next', 1, baseInfo, params, space)
        }
      })
    },
    handleOrderSelected(order) {
      if (order.length === 0) return
      this.model.iesSwitch = order[0].iesSwitch || 0
    },
  },
  async created() {
    this.getBaseDict()
    const params = this.$route.params
    if (params.orderId) {
      this.orderForm.orderId = params.orderId
      const data = await this.$service.getOrderById({ id: params.orderId })
      this.model.iesSwitch = data.iesSwitch
    }
  }
}
</script>
<style lang="stylus" scoped>
.demo-ruleForm-input, .demo-ruleForm-select, .demo-ruleForm-picker
  width 360px
.flex-form-panel
  display flex
  .flex-form-content
    width 250px
    padding-left 10px
  >>>.el-form-item__error
    padding-left 10px
.flex-form-items
  display flex
  padding-left 130px
  .el-form-item+.el-form-item
    margin-left 20px
  .flex-form-content
    width 100px
</style>
